import { Navigate, Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import SpocPremiseView from "./spocPremise.view";
import PremiseDetailView from "./premiseDetail.view";

const useSpocPremiseRoutes = () => (
  <>
    <Route
      path={`${pages.spocPremise.path}/premise/:id`}
      element={<PremiseDetailView />}
    />
    <Route path={`${pages.spocPremise.path}/:tab`} element={<SpocPremiseView />} />
    <Route
      path={pages.spocPremise.path}
      element={<Navigate to={`${pages.spocPremise.path}/spocs`} replace />}
    />
  </>
);

export default useSpocPremiseRoutes;
